import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-downloadpaymentconfirmation',
  templateUrl: './downloadpaymentconfirmation.component.html',
  styleUrls: ['./downloadpaymentconfirmation.component.scss']
})
export class DownloadpaymentconfirmationComponent implements OnInit {

  constructor(
    private router: ActivatedRoute,
    private routerService: Router
  ) {}
  requestId: any;

  ngOnInit(): void {
    this.requestId = +atob(this.router.snapshot.params.id);
    this.routerService.navigate([`/registrydownload/${btoa(this.requestId)}`], { queryParams: { ifpf: btoa('false') } });
  }

}
